export const settings = {
  monitorSplitCountKey: 'settings_monitorSplitCount',
  enlargePageSplitRowKey: 'settings_enlargePageSplitRow',
  enlargePageSplitColumnKey: 'settings_enlargePageSplitColumn',
  enlargePageChangeDurationKey: 'settings_enlargePageChangeDuration',
  enlargePageSelectedGatesKey: 'settings_enlargePageSelectedGates'
}

export const user = {
  infoKey: 'user_info',
  selectedParkGateId: 'selectedParkGateId',
  currentGate: 'currentGate',
  currentPark: 'currentPark',
  currentTask: 'currentTask'
}



// WEBPACK FOOTER //
// ./src/utils/storage-keys.js